import _ from "lodash";
import {QuestionPreview, TopicPreview} from "../../stores/CoursePreviewStore/Types";
import {Enrolment} from "../../stores/EnrolmentStore/Types";

export const getLastLesson = chapters => {
  const lastChapter = _.last(chapters) as TopicPreview;
  const lastQuestion = _.last(lastChapter?.questions);

  return lastQuestion;
};

// Where Next goes. Everywhere but the end of the course that is simply the
// lesson after this one; the lesson player and the opinion votes page both ask
// this, because either can be the last page a learner sees.
//
// At the end of the course there is no lesson after this one. A learner who has
// worked straight through is finished, and goes to their certificate or the
// overview. A learner who skipped one along the way is not, and used to be
// dropped back at the top of the last chapter -- the server's "first question
// of the next chapter" resolved to the chapter they were already in -- with no
// clue which lesson they still owed. They now go straight to it.
//
// enrolment.next_question is the same first-unfinished lesson the overview's
// Continue button uses: the first with no answer, or one still waiting to be
// marked. It is re-read after every answer, so it is current by the time this
// lesson has been answered.
export const nextLessonPath = (
  lesson: QuestionPreview,
  lastLesson: QuestionPreview,
  enrolment: Enrolment,
) => {
  if (lesson?.id !== lastLesson?.id) {
    return lesson?.next_question_path;
  }

  if (enrolment?.state === "passed") {
    return `/enrolments/${enrolment?.id}/certificate`;
  }

  if (enrolment?.state === "failed") {
    return `/enrolments/${enrolment?.id}`;
  }

  // Unless the unfinished lesson is this one, in which case Next would point at
  // the page it is already on.
  if (enrolment?.next_question?.id && enrolment.next_question.id !== lesson?.id) {
    return enrolment.next_question_path;
  }

  return lesson?.next_question_path;
};

// The percentage every in-course surface shows.
//
// A passed enrolment is a finished course, so it reads 100 even if the stored
// figure has not caught up. It often has not: the figure is refreshed by a
// background job, and finishing the last lesson marks the enrolment before that
// job has run. The course overview already forced 100 for a complete course
// (getCourseOverviewState -> StartCard); the lesson sub-nav and chapter drawer
// read the raw figure, so going back into a lesson of a course you had just
// completed took your 100% away and showed 98%.
export const displayPercentage = (enrolment: Enrolment) => {
  if (enrolment?.state === "passed") return 100;

  return Math.max(0, Math.min(100, Math.round(enrolment?.percentage_completed || 0)));
};
